import axios from 'axios';
import { configRefs } from '@utils/constants';

async function duplicateCourseRequest(course) {
  const response = await axios.post(`${await configRefs.apis.userdata.get()}/api/v2/Courses/${encodeURIComponent(course.id)}/Duplicate`, undefined);
  const copiedCourse = {
    ...course,
    id: response.data
  };
  return copiedCourse;
}

export { duplicateCourseRequest };
//# sourceMappingURL=request.duplicate-course.js.map
